"use strict";
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
exports.__esModule = true;
var angular = require("angular");
var basic_table_component_1 = require("../../../../../action/basic-component/basic-table.component");
angular.module('smartorg.r6.mgmts.defineCategory').directive('defineCategory', [
    'shareLink',
    'terminologyService',
    function (shareLink, terminologyService) {
        return {
            restrict: 'E',
            template: require('../../template/define-category.html'),
            scope: {
                onSaveCategory: '&',
                onDeleteCategory: '&',
                onArrangeCategories: '&',
                onUpdateDefaultFilter: '&',
                onUpdateCategory: '&',
                terminology: '=?'
            },
            link: function (scope) {
                // Initialize terminology if not provided
                if (!scope.terminology) {
                    scope.terminology = terminologyService.getDefaultTerminology();
                }
                var hasChanges = false;
                scope.config = [];
                scope.isEmpty = false;
                scope.isDuplicate = false;
                scope.uploadedFile = null;
                scope.entriesToDelete = [];
                scope.showAlert = function (type, title, message) {
                    scope.$emit('workbench:alert', { type: type, title: title, message: message });
                };
                // defaultReportOptions, defaultTreeViewFilters)
                scope.$on('manage:DisplayCategoriesDefinition', function (event, args) {
                    // Not using formattedData.
                    // No longer using table format.
                    hasChanges = false;
                    scope.config = args.config;
                    scope.treeId = args.treeId;
                    if (!scope.config) {
                        scope.config = [];
                    }
                    makeCategoryNameList();
                    scope.showArrangeModalSaveBtn = false;
                    if (!scope.$$phase) {
                        scope.$apply();
                    }
                });
                var makeCategoryNameList = function () {
                    scope.categoryNameList = scope.config.map(function (categoryData, index) {
                        categoryData['index'] = index;
                        return categoryData['CategoryName'];
                    });
                    scope.origCategoryNameList = angular.copy(scope.categoryNameList);
                };
                /**
                 * Check save btn display for editing.
                 */
                scope.handleSaveBtn = function () {
                    scope.showSaveBtn = scope.checkNewEntry();
                    if (scope.action === 'add') {
                        scope.showSaveBtn = scope.editing.CategoryName || false;
                    }
                    else if (scope.editing.CategoryName != '') {
                        if (scope.editing.CategoryName != scope.originalEditing.CategoryName ||
                            scope.editing.AppliesTo != scope.originalEditing.AppliesTo ||
                            scope.editing.IsMultiSelect != scope.originalEditing.IsMultiSelect ||
                            scope.editing.ShowOnCategory != scope.originalEditing.ShowOnCategory ||
                            scope.editing.AdminEditing != scope.originalEditing.AdminEditing ||
                            scope.editing.ContributorEditing != scope.originalEditing.ContributorEditing ||
                            scope.editing.SortEntries != scope.originalEditing.SortEntries ||
                            scope.originalEditing.CategoryEntries.length != scope.editing.CategoryEntries.length ||
                            JSON.stringify(scope.editing.CategoryEntries) !== JSON.stringify(scope.originalEditing.CategoryEntries)) {
                            scope.showSaveBtn = true;
                        }
                        else {
                            for (var i = 0; i < scope.editing.CategoryEntries.length; i++) {
                                if (scope.editing.CategoryEntries[i] != '' &&
                                    scope.originalEditing.CategoryEntries.indexOf(scope.editing.CategoryEntries[i]) == -1) {
                                    scope.showSaveBtn = true;
                                }
                            }
                        }
                    }
                };
                scope.resetCategoryDefn = function () {
                    scope.newEntryName = '';
                    scope.showSaveBtn = false;
                };
                /**
                 * Toggle add category modal (edit modal add mode).
                 */
                scope.addCategory = function () {
                    scope.action = 'add';
                    scope.editDuplicated = false;
                    scope.noName = false;
                    scope.nameExists = false;
                    scope.editing = {
                        CategoryName: '',
                        AppliesTo: 'Leaves',
                        IsMultiSelect: 'false',
                        ShowOnCategory: true,
                        AdminEditing: true,
                        ContributorEditing: false,
                        AutoPropagateUp: 'true',
                        CategoryEntries: [],
                        SortEntries: null
                    };
                    scope.renameEntriesTracker = [];
                };
                scope.addCategoryFromCSV = function () {
                    scope.addCategory();
                    scope.uploadedFile = null;
                    angular.element('input[file-model="uploadedFile"]').val('');
                };
                scope.finishArrangingCategories = function () {
                    savingStatusUpdate(true, 'arrange');
                    scope.origCategoryNameList = angular.copy(scope.categoryNameList);
                    var tmpConfig = [];
                    scope.origCategoryNameList.forEach(function (name) {
                        scope.config.forEach(function (data) {
                            if (name == data['CategoryName']) {
                                tmpConfig.push(data);
                            }
                        });
                    });
                    scope.config = angular.copy(tmpConfig);
                    scope.onArrangeCategories({ categoriesConfig: scope.config });
                };
                scope.$on('DefineCategories:onArrangeCategoriesSuccess', function () {
                    scope.showArrangeModalSaveBtn = false;
                    savingStatusUpdate(false, 'arrange');
                    showAlert('success', 'Success!', 'Categories Arranged Successfully!');
                    angular.element('#arrangeCategoryModal').modal('hide');
                    $('body').removeClass('modal-open');
                    $('.modal-backdrop').remove();
                });
                scope.$on('DefineCategories:checkEntriesToDeleteResponse', function (event, args) {
                    if (Object.keys(args.foundTags).length > 0) {
                        // Convert object to array of strings with counts (e.g., "heart is assigned to 5 nodes")
                        var tagMessages = Object.entries(args.foundTags).map(function (_a) {
                            var tag = _a[0], count = _a[1];
                            return "<strong>" + tag + "</strong> is assigned to " + count + " node" + (count > 1 ? 's' : '');
                        });
                        // Get total nodes affected
                        var totalNodes = Object.values(args.foundTags).reduce(function (sum, count) { return sum + count; }, 0);
                        // Construct the final message based on the number of tags
                        var tagList = tagMessages.join(' and ');
                        var pluralTag = tagMessages.length > 1 ? 'them' : 'it';
                        var message = tagList + " in '<strong>" + args.treeID + "</strong>' " + scope.terminology.portfolio + ". Deleting " + pluralTag + " will remove " + (pluralTag === 'them' ? 'their' : 'its') + " assignment from those " + totalNodes + " node" + (totalNodes > 1 ? 's' : '') + ". Are you sure to delete " + pluralTag + "?";
                        bootbox.dialog({
                            message: "" + message,
                            title: "Confirm Deletion",
                            onEscape: function () {
                                scope.resetEntriesToDelete();
                            },
                            buttons: {
                                confirm: {
                                    label: "Delete",
                                    className: "btn-danger",
                                    callback: function () {
                                        scope.entriesToDelete = [];
                                        scope.proceedEditCategory(args.redirectToAssign);
                                    }
                                },
                                cancel: {
                                    label: "Cancel",
                                    className: "btn-primary",
                                    callback: function () {
                                        scope.resetEntriesToDelete();
                                    }
                                }
                            }
                        });
                    }
                    else {
                        scope.proceedEditCategory(args.redirectToAssign);
                    }
                });
                scope.resetEntriesToDelete = function () {
                    scope.entriesToDelete = [];
                    scope.editing.CategoryEntries = scope.originalEditing.CategoryEntries;
                    scope.editing = angular.copy(scope.editing);
                    scope.$apply();
                };
                scope.resetArrangeCategories = function () {
                    scope.categoryNameList = angular.copy(scope.origCategoryNameList);
                    scope.showArrangeModalSaveBtn = false;
                };
                scope.fileListener = function (files) {
                    var csv = files.item(0);
                    scope.fileFormatErr = csv && csv.type !== 'text/csv' && csv.name.split('.').pop() !== 'csv';
                    var reader = new FileReader();
                    // A handler for the load event (just defining it, not executing it right now)
                    reader.onload = onFileLoad;
                    if (csv) {
                        // use reader to read the selected file
                        reader.readAsText(csv);
                    }
                };
                function onFileLoad(e) {
                    scope.$apply(function () {
                        var res = e.target.result;
                        var lines = readCsv(res);
                        var headerLine = lines.shift();
                        scope.editing.CategoryName = headerLine;
                        scope.checkCategoryName();
                        var contentLines = lines.filter(function (line) { return line !== ''; });
                        var entries = processContentLines(contentLines);
                        scope.editDuplicated = entries.length !== contentLines.length;
                        scope.editing.CategoryEntries = entries;
                    });
                }
                function readCsv(csv) {
                    var allTextLines = csv.split(/\r\n|\n/);
                    var lines = allTextLines.map(function (line) { return line.replace(/[^a-z0-9-_]/gi, ''); });
                    for (var i = 0; i < lines.length; i++) {
                        if (lines[i].length > 0) {
                            while (lines[i].charAt(0) === '_' || lines[i].charAt(0) === '-') {
                                lines[i] = lines[i].slice(1);
                            }
                        }
                    }
                    return lines;
                }
                function processContentLines(lines) {
                    var set = new Set(lines.map(function (line) { return line; }));
                    return Array.from(set);
                }
                scope.importCsv = function () {
                    scope.editDuplicated = false;
                };
                /**
                 * Assign default Show on Leaf Category Page option for category modal
                 * @param isMultiSelect {string} value of isMultiSelect
                 */
                scope.assignShowOnCate = function (isMultiSelect) {
                    scope.editing.ShowOnCategory = isMultiSelect === 'false';
                    scope.onShowOnCategoryChange();
                };
                scope.onShowOnCategoryChange = function () {
                    // default edit permission setting
                    if (!scope.editing.ShowOnCategory) {
                        scope.editing.AdminEditing = false;
                        scope.editing.ContributorEditing = false;
                    }
                    else {
                        scope.editing.AdminEditing = true;
                    }
                };
                scope.onAllowEditingChange = function () {
                    if (!scope.editing.AdminEditing) {
                        scope.editing.ContributorEditing = false;
                    }
                };
                /**
                 * Toggle edit category modal.
                 *
                 * @param category {{}} Category to edit.
                 * @param index {number} Index of this category in config
                 *     array.
                 */
                scope.editCategory = function (category, index) {
                    scope.action = 'edit';
                    scope.showArrangePage = false;
                    scope.editDuplicated = false;
                    scope.noName = false;
                    scope.nameExists = false;
                    scope.renameCategoryToggle = false;
                    scope.categoryNameChanged = false;
                    scope.editing = angular.copy(category);
                    if (!('SortEntries' in scope.editing)) {
                        scope.editing.SortEntries = null;
                    }
                    scope.renameEntriesTracker = scope.editing.CategoryEntries.map(function (entry) { return ({
                        entry: entry,
                        state: false,
                        vals: null,
                        isDuplicate: false
                    }); });
                    scope.originalEditing = angular.copy(category);
                    scope.editingIndex = index;
                    if (category.ShowOnCategory == null) {
                        scope.editing.ShowOnCategory = false;
                        scope.originalEditing.ShowOnCategory = false;
                    }
                    if (category.AdminEditing == null) {
                        scope.editing.AdminEditing = true;
                        scope.originalEditing.AdminEditing = true;
                    }
                    if (category.ContributorEditing == null) {
                        scope.editing.ContributorEditing = false;
                        scope.originalEditing.ContributorEditing = false;
                    }
                };
                scope.sort = function () {
                    scope.editing.CategoryEntries.sort();
                    if (scope.editing.SortEntries == 'desc') {
                        scope.editing.CategoryEntries.reverse();
                    }
                    var sortedTracker = [];
                    scope.editing.CategoryEntries.forEach(function (entries) {
                        scope.renameEntriesTracker.forEach(function (trackerEntries) {
                            if (entries == trackerEntries.entry) {
                                sortedTracker.push(trackerEntries);
                            }
                        });
                    });
                    if (sortedTracker.length == scope.renameEntriesTracker.length) {
                        scope.renameEntriesTracker = angular.copy(sortedTracker);
                    }
                };
                scope.sortEntries = function () {
                    if (!scope.editing.SortEntries || scope.editing.SortEntries == 'desc') {
                        scope.editing.SortEntries = 'asc';
                        scope.sort();
                    }
                    else {
                        scope.editing.SortEntries = 'desc';
                        scope.sort();
                    }
                    scope.handleSaveBtn();
                };
                /**
                 * Save the edited/new category and go to Assign Category page.
                 */
                scope.saveAndAssign = function () {
                    scope.saveEditCategory(true);
                };
                scope.goToAssignCategories = function () {
                    scope.$emit('displayAssignCategories', { hasChanges: hasChanges });
                };
                /**
                 * Save category through API. Sending the current editing
                 * category to server.
                 *
                 * Should also have a separate one to handle delete.
                 */
                scope.proceedEditCategory = function (redirectToAssign) {
                    if (redirectToAssign === void 0) { redirectToAssign = false; }
                    var proceed = checkEmptyDuplicateCategories(scope.editing.CategoryEntries);
                    if (proceed) {
                        // scope.isEmpty = false
                        scope.assignCategories = false;
                        scope.editing.AutoPropagateUp = 'true';
                        scope.changedCategoryName = {};
                        if (scope.checkNewEntry()) {
                            scope.editing.CategoryEntries.push(scope.newEntryName.trim());
                            scope.newEntryName = '';
                        }
                        if (scope.checkCategoryName()) {
                            scope.editing.CategoryName = scope.editing.CategoryName.trim();
                            if (scope.action == 'add') {
                                scope.config.push(scope.editing);
                            }
                            else {
                                scope.config[scope.editingIndex] = scope.editing;
                                if (scope.categoryNameChanged) {
                                    scope.changedCategoryName = {
                                        oldName: scope.originalEditing.CategoryName,
                                        newName: scope.editing.CategoryName
                                    };
                                }
                            }
                            updateCategoryFilter();
                            savingStatusUpdate(true, 'edit');
                            scope.onSaveCategory({
                                category: scope.editing,
                                redirectToAssign: redirectToAssign,
                                renameEntriesTracker: scope.renameEntriesTracker,
                                changedCategoryName: scope.changedCategoryName,
                                action: scope.action,
                                index: scope.editingIndex
                            });
                            scope.resetCategoryDefn();
                        }
                        scope.originalEditing = scope.editing;
                        scope.showSaveBtn = false;
                        hasChanges = true;
                    }
                    else {
                        scope.showAlert("danger", "Error: ", "Category names cannot be " + (scope.isEmpty ? "empty" : "duplicated") + "!");
                    }
                };
                scope.saveEditCategory = function (redirectToAssign) {
                    if (redirectToAssign === void 0) { redirectToAssign = false; }
                    //console.log(scope.entriesToDelete);
                    if (scope.entriesToDelete.length > 0) {
                        scope.$emit('workbench:checkEntriesToDelete', { entries: scope.entriesToDelete, redirectToAssign: redirectToAssign });
                    }
                    else {
                        scope.proceedEditCategory(redirectToAssign);
                    }
                };
                function updateTagsForTreeFilter() {
                    if (scope.editing.index !== undefined && scope.config[scope.editing.index]) {
                        // Update the existing object at the specified index
                        scope.config[scope.editing.index] = __assign({}, scope.editing);
                    }
                    else {
                        // Append the object if the index is not valid or doesn't exist
                        scope.config.push(__assign({}, scope.editing, { index: scope.config.length }));
                    }
                    // let parsedTags = scope.config.reduce((acc, categoryData) => {
                    //     categoryData.CategoryEntries.forEach(entry => {
                    //         acc.push(`${categoryData.CategoryName}:${entry}`);
                    //     });
                    //     return acc;
                    // }, []);
                    // console.log(parsedTags);
                    scope.onUpdateCategory({ categories: scope.config });
                    ///
                }
                // create a function whome an array of strings will be given, if any string is empty, return false
                function checkEmptyCategories(cats) {
                    for (var i = 0; i < cats.length; i++) {
                        if (cats[i] == "") {
                            scope.isEmpty = true;
                            return;
                        }
                    }
                    scope.isEmpty = false;
                }
                function checkEmptyDuplicateCategories(cats) {
                    // Reset scope flags
                    scope.isEmpty = false;
                    scope.isDuplicate = false;
                    var seen = new Set();
                    var newEntry = scope.newEntryName ? scope.newEntryName.trim().toLowerCase() : ""; // Normalize new entry name for case-insensitive comparison
                    for (var i = 0; i < cats.length; i++) {
                        var catName = cats[i].trim().toLowerCase(); // Normalize for case-insensitivity
                        if (catName === "") {
                            scope.isEmpty = true;
                            return false; // Return immediately if an empty string is found
                        }
                        if (seen.has(catName)) {
                            scope.isDuplicate = true;
                            return false; // Return immediately if a duplicate (case-insensitive) is found
                        }
                        seen.add(catName);
                    }
                    // Check if scope.newEntryname is a duplicate in the list
                    if (newEntry && seen.has(newEntry)) {
                        scope.isDuplicate = true;
                        return false;
                    }
                    return true; // If no empty or duplicate values are found
                }
                function updateCategoryFilter(deleteCategoryName) {
                    if (deleteCategoryName === void 0) { deleteCategoryName = null; }
                    var includedFilters = shareLink.getTreeFilters();
                    var excludeFilters = shareLink.getTreeExcludeFilters();
                    if (includedFilters != null) {
                        // Split the filters into individual groups based on ' and '
                        var includedGroups = includedFilters.split(' and ');
                        // Process each group
                        var filteredIncludedGroups = includedGroups.map(function (group) {
                            // Preserve parentheses by trimming them temporarily
                            var trimmedGroup = group.trim();
                            var hasParentheses = trimmedGroup.startsWith('(') && trimmedGroup.endsWith(')');
                            var content = hasParentheses ? trimmedGroup.slice(1, -1) : trimmedGroup;
                            // Split the group into individual entries based on 'or'
                            var entries = content.split(' or ');
                            // Filter each entry in the group
                            var filteredEntries = entries.filter(function (entry) {
                                // Split each entry at the colon
                                var incParts = entry.split(':');
                                if (deleteCategoryName) {
                                    // Exclude entries for the deleted category
                                    if (deleteCategoryName && incParts[0] === deleteCategoryName) {
                                        return false;
                                    }
                                    else {
                                        return true;
                                    }
                                }
                                else {
                                    // Check if the part after the colon is in categoryEntries and that the category matches
                                    return incParts[0] !== scope.editing.CategoryName || scope.editing.CategoryEntries.includes(incParts[1]);
                                }
                            });
                            // Rejoin the filtered entries with 'or' and restore parentheses if needed
                            var filteredGroup = filteredEntries.join(' or ');
                            return hasParentheses ? (filteredGroup ? "(" + filteredGroup + ")" : '') : filteredGroup;
                        });
                        // Remove empty groups and rejoin using 'and'
                        var includedRes = filteredIncludedGroups
                            .filter(function (group) { return group.trim() !== ''; }) // Remove empty groups
                            .join(' and ');
                        // Ensure there are no trailing or leading 'and'
                        var cleanedIncludedRes = includedRes.trim();
                        // Update the filters in the share link
                        shareLink.setTreeFilters(cleanedIncludedRes);
                    }
                    if (excludeFilters != null) {
                        // Filter out removed categories from excluded filter
                        var excludedRes = excludeFilters.filter(function (entry) {
                            // Split each entry by the colon
                            var excParts = entry.split(':');
                            if (deleteCategoryName) {
                                // Exclude entries for the deleted category
                                if (deleteCategoryName && excParts[0] === deleteCategoryName) {
                                    return false;
                                }
                                else {
                                    return true;
                                }
                            }
                            else {
                                // Check if the category part matches categoryname and if the category is in categoryEntries
                                return excParts[0] !== scope.editing.CategoryName || scope.editing.CategoryEntries.includes(excParts[1]);
                            }
                        });
                        shareLink.setTreeExcludeFilters(excludedRes);
                    }
                    // Default filter
                    var defaultIncludedFilters = shareLink.getDefaultTreeFilters();
                    var defaultExcludeFilters = shareLink.getDefaultTreeExcludeFilters();
                    var defaultIncludedRes = defaultIncludedFilters;
                    var defaultExcludeRes = defaultExcludeFilters;
                    var isIncludedFilterChanged = false;
                    var isexcludedFilterChanged = false;
                    if (defaultIncludedFilters != null) {
                        // Split the filters into individual groups based on ' and '
                        var defaultIncludedGroups = defaultIncludedFilters.split(' and ');
                        // Process each group
                        var filteredDefaultGroups = defaultIncludedGroups.map(function (group) {
                            // Preserve parentheses by trimming them temporarily
                            var trimmedGroup = group.trim();
                            var hasParentheses = trimmedGroup.startsWith('(') && trimmedGroup.endsWith(')');
                            var content = hasParentheses ? trimmedGroup.slice(1, -1) : trimmedGroup;
                            // Split the group into individual entries based on 'or'
                            var entries = content.split(' or ');
                            // Filter each entry in the group
                            var filteredEntries = entries.filter(function (entry) {
                                // Split each entry at the colon
                                var defParts = entry.split(':');
                                if (deleteCategoryName) {
                                    // Exclude entries for the deleted category
                                    if (deleteCategoryName && defParts[0] === deleteCategoryName) {
                                        return false;
                                    }
                                    else {
                                        return true;
                                    }
                                }
                                else {
                                    // Check if the part after the colon is in categoryEntries and the category matches
                                    return defParts[0] !== scope.editing.CategoryName || scope.editing.CategoryEntries.includes(defParts[1]);
                                }
                            });
                            // Rejoin the filtered entries with 'or' and restore parentheses if needed
                            var filteredGroup = filteredEntries.join(' or ');
                            return hasParentheses ? (filteredGroup ? "(" + filteredGroup + ")" : '') : filteredGroup;
                        });
                        // Remove empty groups and rejoin using 'and'
                        defaultIncludedRes = filteredDefaultGroups
                            .filter(function (group) { return group.trim() !== ''; }) // Remove empty groups
                            .join(' and ');
                        // Check if any key was removed
                        isIncludedFilterChanged = defaultIncludedFilters.trim() != defaultIncludedRes.trim();
                        if (isIncludedFilterChanged) {
                            console.log('Default included filters have been updated. Keys were removed or modified.');
                            shareLink.setDefaultTreeFilters(defaultIncludedRes);
                        }
                        else {
                            console.log('Default included filters remain unchanged.');
                        }
                    }
                    if (defaultExcludeFilters != null) {
                        // Filter out removed categories from excluded filter
                        defaultExcludeRes = defaultExcludeFilters.filter(function (entry) {
                            // Split each entry by the colon
                            var excParts = entry.split(':');
                            if (deleteCategoryName) {
                                // Exclude entries for the deleted category
                                if (deleteCategoryName && excParts[0] === deleteCategoryName) {
                                    return false;
                                }
                                else {
                                    return true;
                                }
                            }
                            else {
                                // Check if the category part matches categoryname and if the category is in categoryEntries
                                return excParts[0] !== scope.editing.CategoryName || scope.editing.CategoryEntries.includes(excParts[1]);
                            }
                        });
                        isexcludedFilterChanged = defaultExcludeFilters != defaultExcludeRes;
                        if (isexcludedFilterChanged) {
                            shareLink.setDefaultTreeExcludeFilters(defaultExcludeRes);
                        }
                    }
                    if (isIncludedFilterChanged || isexcludedFilterChanged) {
                        console.log(defaultIncludedRes);
                        console.log(defaultExcludeRes);
                        // Hit the api
                        scope.$emit('defineCategory:setDefaultFilter', { filterLogic: defaultIncludedRes, excludedTags: defaultExcludeRes });
                        scope.onUpdateDefaultFilter({
                            filterLogic: defaultIncludedRes,
                            excludedTags: defaultExcludeRes
                        });
                    }
                }
                scope.$on('DefineCategories:onSaveCategorySuccess', function (event, args) {
                    makeCategoryNameList();
                    var editCategoryName = args.categoryName;
                    savingStatusUpdate(false, 'edit');
                    showAlert('success', 'Success!', 'Category ' + editCategoryName + ' Saved Successfully!');
                    updateTagsForTreeFilter();
                    angular.element('#editCategoryModal').modal('hide');
                    $('body').removeClass('modal-open');
                    $('.modal-backdrop').remove();
                });
                /**
                 * Delete an existing category.
                 *
                 * @param name {string} Name of this category in config
                 *     array.
                 * @param index {number} Index of the category.
                 */
                scope.showDeleteCategoryModel = function (name, index) {
                    scope.deteleCategoryName = name;
                    scope.deteleCategoryIndex = index;
                };
                scope.deleteCategory = function () {
                    scope.actionType = 'delete';
                    savingStatusUpdate(true, 'delete');
                    updateCategoryFilter(scope.deteleCategoryName);
                    scope.onDeleteCategory({ categoryName: scope.deteleCategoryName });
                };
                scope.$on('DefineCategories:onDeleteCategorySuccess', function (event, args) {
                    var deletedCategoryName = args.categoryName;
                    savingStatusUpdate(false, 'delete');
                    showAlert('success', 'Success!', 'Category ' + deletedCategoryName + ' Deleted Successfully!');
                    angular.element('#deleteCategoryModal').modal('hide');
                    $('body').removeClass('modal-open');
                    $('.modal-backdrop').remove();
                    scope.config.splice(scope.deteleCategoryIndex, 1);
                    makeCategoryNameList();
                    scope.$apply();
                    hasChanges = true;
                });
                function savingStatusUpdate(saving, actionType) {
                    scope.showSpinner = saving;
                    var clickClass = saving ? 'click-disabled' : 'click-enabled';
                    var selectedElem = '#' + actionType + 'CategoryModal *';
                    angular.element(selectedElem).attr('disabled', saving).addClass(clickClass);
                }
                function showAlert(type, title, message) {
                    scope.$emit('workbench:alert', { type: type, title: title, message: message });
                }
                /**
                 * Add an entry to editing category.
                 *
                 * @param $event {{}} To get current element.
                 */
                scope.addEntry = function ($event) {
                    if ($event.keyCode === 13) {
                        if (scope.checkNewEntry()) {
                            scope.editing.CategoryEntries.push(scope.newEntryName.trim());
                            scope.renameEntriesTracker.push({
                                entry: scope.newEntryName.trim(),
                                state: false,
                                vals: null,
                                isDuplicate: false
                            });
                            $event.currentTarget.value = '';
                            scope.newEntryName = '';
                            $event.currentTarget.focus();
                        }
                        if (scope.editing.SortEntries) {
                            scope.sort();
                        }
                    }
                    scope.handleSaveBtn();
                };
                /**
                 * Check if entry name is valid.
                 *
                 * @returns {boolean} True is valid.
                 */
                scope.checkNewEntry = function () {
                    if (scope.newEntryName && scope.newEntryName.trim().length) {
                        scope.newEntryName = removeSpecialChar(scope.newEntryName);
                        // scope.editDuplicated = scope.editing.CategoryEntries.indexOf(scope.newEntryName.trim()) > -1;
                        scope.editDuplicated = scope.editing.CategoryEntries.some(function (entry) {
                            return entry.toLowerCase() === scope.newEntryName.trim().toLowerCase();
                        });
                        return !scope.editDuplicated;
                    }
                    else {
                        return false;
                    }
                };
                /**
                 * Delete an entry from editing category.
                 *
                 * @param index {number} Index of an entry.
                 */
                scope.deleteEntry = function (index) {
                    if (index > -1) {
                        scope.entriesToDelete.push(scope.editing.CategoryName + ':' + scope.editing.CategoryEntries[index]);
                        scope.editing.CategoryEntries.splice(index, 1);
                        scope.renameEntriesTracker.splice(index, 1);
                    }
                    scope.handleSaveBtn();
                };
                scope.renameEntryToggle = function (index, state) {
                    if (scope.renameEntriesTracker[index]) {
                        scope.renameEntriesTracker[index].state = state;
                    }
                    else {
                        scope.renameEntriesTracker = scope.editing.CategoryEntries.map(function (entry) { return ({
                            entry: entry,
                            state: false,
                            vals: null,
                            isDuplicate: false
                        }); });
                        scope.renameEntriesTracker[index].state = state;
                    }
                    scope.handleSaveBtn();
                };
                scope.resetEntry = function (index, state, entry) {
                    if (index > -1) {
                        scope.renameEntriesTracker[index].state = state;
                        scope.renameEntriesTracker[index].vals = null;
                        scope.renameEntriesTracker[index].isDuplicate = false;
                        // scope.editing.CategoryEntries[index] = scope.originalEditing.CategoryEntries[index];
                        scope.editing.CategoryEntries[index] =
                            scope.action == 'edit' && scope.originalEditing && scope.originalEditing.CategoryEntries[index] !== undefined ? scope.originalEditing.CategoryEntries[index] :
                                scope.renameEntriesTracker && scope.renameEntriesTracker[index] !== undefined ? scope.renameEntriesTracker[index].entry :
                                    "";
                    }
                    scope.handleSaveBtn();
                };
                scope.renameEntry = function (entry, index) {
                    entry = entry.replace(/[^a-z0-9-_]/gi, '');
                    if (entry.length > 0) {
                        while (entry.charAt(0) === '_' || entry.charAt(0) === '-') {
                            entry = entry.slice(1);
                        }
                    }
                    if (index > -1) {
                        scope.renameEntriesTracker[index].vals = {
                            oldTag: scope.originalEditing ? scope.originalEditing.CategoryEntries[index] : "",
                            newTag: entry
                        };
                        scope.renameEntriesTracker[index].entry = entry;
                        scope.editing.CategoryEntries[index] = entry;
                        for (var i = 0; i < scope.editing.CategoryEntries.length; i++) {
                            if (i != index && entry.toLowerCase() == scope.editing.CategoryEntries[i].toLowerCase()) {
                                scope.renameEntriesTracker[index].isDuplicate = true;
                                break;
                            }
                            else {
                                scope.renameEntriesTracker[index].isDuplicate = false;
                            }
                        }
                    }
                };
                scope.renameCategoryToggleFn = function (state) {
                    checkAndFilterCategoryNameChars();
                    scope.renameCategoryToggle = state;
                };
                scope.resetCategoryName = function () {
                    scope.editing.CategoryName = angular.copy(scope.originalEditing.CategoryName);
                    scope.noName = false;
                    scope.nameExists = false;
                    scope.renameCategoryToggleFn(false);
                    scope.handleSaveBtn();
                };
                var checkAndFilterCategoryNameChars = function () {
                    scope.editing.CategoryName = scope.editing.CategoryName.replace(/[^a-z0-9-_]/gi, '');
                    if (scope.editing.CategoryName.length > 0) {
                        while (scope.editing.CategoryName.charAt(0) === '_' || scope.editing.CategoryName.charAt(0) === '-') {
                            scope.editing.CategoryName = scope.editing.CategoryName.slice(1);
                        }
                    }
                };
                scope.checkCategoryNameChange = function () {
                    checkAndFilterCategoryNameChars();
                    scope.categoryNameChanged = scope.editing.CategoryName != '' && scope.editing.CategoryName != scope.originalEditing.CategoryName;
                    if (scope.action == 'edit' && scope.editing.CategoryName !== scope.originalEditing.CategoryName) {
                        scrutinizeCategoryName();
                    }
                    scope.handleSaveBtn();
                };
                scope.arrangeEntries = function () {
                    scope.showArrangePage = true;
                };
                scope.finishArranging = function () {
                    scope.showArrangePage = false;
                    scope.handleSaveBtn();
                };
                /**
                 * Necessary for sorting category entries.
                 */
                $(function () {
                    angular.element('#sortCategoryEntries').sortable({
                        placeholder: 'treeview-sort-placeholder',
                        stop: function (event, ui) {
                            scope.editing.CategoryEntries = angular.element('#sortCategoryEntries').sortable('toArray');
                            setTimeout(function () {
                                scope.$apply();
                            }, 0);
                        }
                    });
                });
                /**
                 * Necessary for sorting categories.
                 */
                $(function () {
                    angular.element('#arrangeCategories').sortable({
                        placeholder: 'treeview-sort-placeholder',
                        stop: function (event, ui) {
                            scope.categoryNameList = angular.element('#arrangeCategories').sortable('toArray');
                            scope.showArrangeModalSaveBtn = JSON.stringify(scope.categoryNameList) !== JSON.stringify(scope.origCategoryNameList);
                            setTimeout(function () {
                                scope.$apply();
                            }, 0);
                        }
                    });
                });
                function scrutinizeCategoryName() {
                    scope.editing.CategoryName = removeSpecialChar(scope.editing.CategoryName);
                    scope.noName = !(scope.editing.CategoryName && scope.editing.CategoryName.trim().length);
                    scope.nameExists = scope.isCategoryExists(scope.editing.CategoryName);
                }
                /**
                 * Check if new category name is available. Only check
                 * in add mode. Ignore edit mode since no name change.
                 *
                 * @returns {boolean} True if valid.
                 */
                scope.checkCategoryName = function () {
                    if (scope.action == 'edit') {
                        return true;
                    }
                    if (scope.action == 'add') {
                        scope.showSaveBtn = scope.editing.CategoryName != '';
                    }
                    scrutinizeCategoryName();
                    return !(scope.noName || scope.nameExists);
                };
                /**
                 * Check if a category is existing in current config.
                 *
                 * @param name {string} Category name to check.
                 * @returns {boolean} True if exist.
                 */
                scope.isCategoryExists = function (name) {
                    for (var i = 0; i < scope.config.length; i++) {
                        if (scope.config[i].CategoryName == name) {
                            return true;
                        }
                    }
                    return false;
                };
                /**
                 * Remove all invalid charactors on enter. Efficiency is
                 * not good, but categories and tags won't have long name.
                 *
                 * @param input {string} Input string.
                 * @returns {any} Output string. Basically it is input
                 *     string without special chars.
                 */
                var removeSpecialChar = function (input) {
                    if (input.length > 0) {
                        while (input.charAt(0) === '_' || input.charAt(0) === '-') {
                            input = input.slice(1);
                        }
                    }
                    for (var i = 0; i < input.length; i++) {
                        if (input[i] == ' ') {
                            input = input.replace(/\s/g, '');
                        }
                        if (input.charCodeAt(i) < 45 ||
                            (input.charCodeAt(i) > 45 && input.charCodeAt(i) < 48) ||
                            (input.charCodeAt(i) > 57 && input.charCodeAt(i) < 65) ||
                            (input.charCodeAt(i) > 90 && input.charCodeAt(i) < 95) ||
                            (input.charCodeAt(i) > 95 && input.charCodeAt(i) < 97) ||
                            input.charCodeAt(i) > 122) {
                            input = input.slice(0, -1);
                        }
                    }
                    return input;
                };
                scope.back = function () {
                    scope.$emit('workbench:back', { reload: hasChanges });
                };
                /**
                 * Export categories to csv file
                 */
                scope.exportCsv = function (csvFormat) {
                    if (csvFormat === void 0) { csvFormat = undefined; }
                    var filename = "Categories_" + scope.treeId + "_" + basic_table_component_1.getDate() + ".csv";
                    var csv = generateCsv(scope.config, csvFormat);
                    var blob = new Blob([csv], { type: 'text/plain;charset=utf-8' });
                    saveAs(blob, filename);
                };
                scope.exportTemplateCsv = function () {
                    var filename = "Category_Input_Template.csv";
                    var csv = 'CategoryName\nEntry1\nEntry2\nEntry3\nEntry4';
                    var blob = new Blob([csv], { type: 'text/plain;charset=utf-8' });
                    saveAs(blob, filename);
                };
                function generateCsv(categories, csvFormat) {
                    if (!categories) {
                        return '';
                    }
                    var cellSeparator = csvFormat === 'EU' ? ';' : ',';
                    var decimalPoint = csvFormat === 'EU' ? ',' : '.';
                    var headerLine = categories.map(function (category) { return formatCell(category.CategoryName, decimalPoint); }).join(cellSeparator);
                    var maxRows = categories.reduce(function (maxLen, category) { return Math.max(category.CategoryEntries.length, maxLen); }, 0);
                    var contentLines = [];
                    var _loop_1 = function (i) {
                        contentLines.push(categories.map(function (category) { return formatCell(category.CategoryEntries[i], decimalPoint) || ''; }).join(cellSeparator));
                    };
                    for (var i = 0; i < maxRows; i++) {
                        _loop_1(i);
                    }
                    contentLines.unshift(headerLine);
                    return contentLines.join('\n');
                }
                function formatCell(val, decimalPoint) {
                    if (typeof val === 'undefined' || val === null) {
                        return '""';
                    }
                    var str = val.toString().trim();
                    if (!isNaN(val)) {
                        return str.replace('.', decimalPoint);
                    }
                    return "\"" + str + "\"";
                }
            }
        };
    },
]);
//# sourceMappingURL=define-category-directive.js.map


// WEBPACK FOOTER //
// ./app/widgets/management/define-category/app/js/plumbing/define-category-directive.js